import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitStairNegotiation extends React.Component {

    render() {
        let dropdownOptions = [
            { id: '1 HR', value: '1 HR' },
            { id: '2 HR', value: '2 HR' },
            { id: 'AD', value: 'AD' },
            { id: 'Pain', value: 'Pain' },
            { id: 'No Pain', value: 'No Pain' },
            { id: 'Min Assistance', value: 'Min Assistance' },
            { id: 'Mod Assistance', value: 'Mod Assistance' },
            { id: 'Maximal Assistance', value: 'Maximal Assistance' },
            { id: 'Unsafe', value: 'Unsafe' }

        ];

        return (
            <div>
                <div className={styles.dropdown_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait - Stair Negotiation' />
                    <label className={styles.label}>Stair Negotiation</label>
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAISTAIR'
                        className={styles.dropdown}
                        customOptions={dropdownOptions}
                    />
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel_indent}>Comments</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAISTAIRCOMMENTS'
                        className={styles.textarea}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAISTAIR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAISTAIRCOMMENTS
            ? true : false
    };
}

const connectedObservationGaitStairNegotiation = connect(mapStateToProps)(ObservationGaitStairNegotiation);
export { connectedObservationGaitStairNegotiation as ObservationGaitStairNegotiation };


